<template>
	<div class="d-flex align-items-center" @click.stop>
		<slot>
			<div
				class="h2 ml-2 mt-2"
				:class="titleClass"
				v-if="title"
				:style="`font-size: ${titleFontSize}; font-weight: ${titleFontWeight}`"
			>
				{{ title }}
			</div>
		</slot>
		<BaseSwitch
			id="themeSwitcher"
			class="base-switch"
			:class="isDarkMode ? 'bg-secondary' : 'bg-primary'"
			v-model:value="isDarkMode"
			style="border-radius: 12px"
		/>
		<slot name="end"></slot>
	</div>
</template>

<script>
import BaseSwitch from "@/components/BaseSwitch";

export default {
	name: "ThemeSwitcher",
	components: {
		BaseSwitch,
	},
	data: () => ({
		isDarkMode: false,
		body: null,
		html: null,
		ready: false,
	}),
	props: {
		title: {
			type: String,
			default: "",
		},
		titleClass: {
			type: String,
			default: "text-white",
		},
		titleFontSize: {
			type: String,
			default: "16px",
		},
		titleFontWeight: {
			type: String,
			default: "600",
		},
	},
	watch: {
		isDarkMode: function (val) {
			if (!this.ready) return;
			this.switchTheme(val);
		},
	},
	mounted() {
		this.body = document.querySelector("body");
		this.html = document.querySelector("html");
		this.isDarkMode = !!this.body.classList.contains("dark");

		if (this.isDarkMode) {
			this.setDark({htmlOnly: true});
		}
		this.$nextTick(() => (this.ready = true));
	},
	methods: {
		switchTheme(toDark) {
			toDark ? this.setDark() : this.setLight();
		},
		setDark({htmlOnly} = {htmlOnly: false}) {
			!htmlOnly && this.body.classList.add("dark");
			this.html.style.background = "#333";
		},
		setLight() {
			this.body.classList.remove("dark");
			this.html.style.background = "#fff";
		},
	},
};
</script>

<style scoped scoped>
.theme-wrapper {
	display: flex;
	align-items: center;
}
</style>
